module.exports = __webpack_public_path__ + "static/media/left.3e21778a.svg";